import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { apiError, useAuth } from "../lib/auth";
import { AuthCard, Field, FormError, SubmitBtn } from "../components/auth/AuthCard";

export function AcceptInvite() {
  const { token } = useParams();
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [inv, setInv] = useState(null);
  const [form, setForm] = useState({ name: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/auth/invite/${token}`).then((r) => setInv(r.data)).catch((e) => setError(apiError(e))); }, [token]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { const { data } = await api.post("/auth/accept-invite", { token, ...form }); signIn(data); nav("/app", { replace: true }); }
    catch (err) { setError(apiError(err)); }
    setBusy(false);
  };

  return (
    <AuthCard testid="accept-invite-page" title="Join your team"
      subtitle={inv ? `You've been invited as ${inv.role} (${inv.email}).` : error ? "" : "Checking your invite…"}>
      <FormError error={error} />
      {inv && (
        <form onSubmit={submit}>
          <Field label="Your name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} testid="invite-name-input" />
          <Field label="Create password (8+ characters)" type="password" required minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} testid="invite-password-input" />
          <SubmitBtn busy={busy} testid="invite-accept-btn">ACCEPT & ENTER</SubmitBtn>
        </form>
      )}
      <p className="mt-6 text-[10px] leading-relaxed text-white/30" data-testid="invite-analytics-notice">AEGIS collects product usage analytics (pages visited, actions, errors and MARI questions) to improve the product.</p>
    </AuthCard>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await api.post("/auth/reset-password", { token: params.get("token"), password: pw }); nav("/login", { replace: true }); }
    catch (err) { setError(apiError(err)); }
    setBusy(false);
  };
  return (
    <AuthCard testid="reset-password-page" title="Choose a new password">
      <form onSubmit={submit}>
        <FormError error={error} />
        <Field label="New password (8+ characters)" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} testid="reset-password-input" />
        <SubmitBtn busy={busy} testid="reset-password-submit">UPDATE PASSWORD</SubmitBtn>
      </form>
    </AuthCard>
  );
}
